import React from 'react';
import { Translate } from 'react-jhipster';
import { Alert } from 'react-bootstrap';

const PageNotFound = () => {
  return (
    <div>
      <Alert variant="danger">
        <Translate contentKey="error.http.404">The page does not exist.</Translate>
      </Alert>
    </div>
  );
};

export default PageNotFound;
